import isBoolean from "lodash/isBoolean";
import isNil from "lodash/isNil";
import isNumber from "lodash/isNumber";
import isString from "lodash/isString";
import { useMemo } from "react";

export const useDefaultColumnDefsLoanPipelineTable = (params = {}) => {
  return useMemo(() => {
    const isEmptyValue = (p) => {
      return isNil(p?.value) || (isString(p?.value) && p?.value === "None");
    };
    return {
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,

      showRowGroup: false,
      valueFormatter: (p) => {
        if (isEmptyValue(p)) {
          return "-";
        }
      },
      // cellStyle: (p) => {
      //   if (isBoolean(p?.value) || isNumber(p?.value)) {
      //     return;
      //   }
      //   if (isEmptyValue(p)) {
      //     return {
      //       opacity: 0.4,
      //     };
      //   }
      // },

      minWidth: 150,
      sortable: true,
      resizable: true,

      filterParams: {
        buttons: ["clear", "apply"],
      },
      ...params,
    };
  }, [params]);
};
